/* eslint-disable max-len */
import React from 'react'

import styled from 'styled-components'

import { above, fontSize, space } from '../../../style/design-system'

const Values = ({ className }) => (
  <div className={`${className} py-9 py-lg-10`}>
    <div className="container">

      <h2 className="m-0 blue text-center">Our Values</h2>
      <div className="values-wrapper">
        <div className="value-group">
          <h3 className="value-title teal mt-0 mb-6 mb-md-0">Act with Integrity</h3>
          <p className="value-text">We operate honestly and ethically in a compliant fashion. We are fair and trustworthy in our interactions with all we serve. Our team members, at all levels, lead by example and strive to do the right thing for our students and for each other. We are disciplined professionals who strive to be straightforward and dependable.</p>
        </div>
        <div className="value-group">
          <h3 className="value-title teal mt-0 mb-6 mb-md-0">Champion Student Outcomes</h3>
          <p className="value-text">We live by a strong commitment to our students and are passionate about preparing them for meaningful careers. We are deeply dedicated to ensuring students’ educational and career success. We excel at building our students’ confidence and empowering them to reach their full potential.</p>
        </div>
        <div className="value-group">
          <h3 className="value-title teal mt-0 mb-6 mb-md-0">Commit to Team Member Success</h3>
          <p className="value-text">We are committed to our team members’ success. We strive to create an environment that attracts and retains the best talent while offering continuous learning, professional development and career growth opportunities. We recognize and reward our team members for their contributions to the organization and to our students.</p>
        </div>
        <div className="value-group">
          <h3 className="value-title teal mt-0 mb-6 mb-md-0">Pursue Results with Purpose</h3>
          <p className="value-text">We pursue results with a sense of purpose reflective of our student-centered mission. We take responsibility for supporting ambitious student outcomes and hold each other accountable to this end. We think strategically and critically, greet new ideas openly, and look for innovative solutions to challenges.</p>
        </div>
        <div className="value-group">
          <h3 className="value-title teal mt-0 mb-6 mb-md-0">Have Fun. Build Energy.</h3>
          <p className="value-text">Enjoying what we do is central to achieving our goals. Building energy, having fun, being optimistic, and creating a positive working environment are all critical to our success and that of our students. We strive to be inspired and to inspire others. We consistently show appreciation and celebrate our success, both large and small.</p>
        </div>
        <div className="value-group">
          <h3 className="value-title teal mt-0 mb-6 mb-md-0">Work as One</h3>
          <p className="value-text">We believe that diverse, inclusive teams produce breakthrough results. We strive to build and maintain positive relationships with team members from all types of backgrounds by showing respect and humility when interacting with each other and resolving conflicts in a constructive manner. By working together, we win together, ensuring that the goals of the institution are the focal point of our efforts.</p>
        </div>
      </div>
    </div>
  </div>
)

export default styled(Values)`
  .value-group {
    padding: ${space.f} ${space.c};
    border-bottom: 1px solid black;
    &:last-child {
      border-bottom: none;
      padding-bottom: 0;
    }
    ${above.md`
      display: flex;
      justify-content: center;
      align-items: center;
      padding: ${space.g} 0;
    `}
    ${above.xl`
      max-width: 60rem;
      margin: auto;
    `}
    .value-title {
      text-align: center;
      flex: 0 0 50%;
      font-size: ${fontSize.i};
      ${above.md`
        padding: 0 ${space.f};
        font-size: ${fontSize.j};
      `}
      ${above.lg`
        padding: 0 ${space.g};
        font-size: ${fontSize.k};
      `}
    }
    .value-text {
      flex: 0 0 50%;
      ${above.md`
        padding-left: ${space.f};
      `}
      ${above.lg`
        padding-left: ${space.g};
      `}
    }
    &:nth-child(odd) {
    }
    &:nth-child(even) {
      .value-title {
        order: 1;
      }
      .value-text {
        order: 0;
        ${above.md`
          padding: 0 ${space.f} 0 0;
        `}
        ${above.lg`
          padding: 0 ${space.g} 0 0;
        `}
      }
    }
  }
`
